import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faFileExport, faSpinner, faTimes } from '@fortawesome/pro-solid-svg-icons';

import { addAttachmentToProject } from 'components/documents/actions';

export class AddAttachmentToProjectIcon extends React.Component {
  static propTypes = {
    addAttachmentToProject: PropTypes.func.isRequired,
    attachmentId: PropTypes.number.isRequired,
    projectId: PropTypes.number.isRequired,
    taskId: PropTypes.number.isRequired
  }

  state = {
    addingAttachment: false,
    addingFailed: false,
    addingSucceded: false
  }

  handleClick = () => {
    this.setState({ addingAttachment: true });
    const { addAttachmentToProject, projectId, taskId, attachmentId } = this.props;

    addAttachmentToProject(false, projectId, taskId, attachmentId).then(() => {
      this.setState({ addingAttachment: false, addingSucceded: true });

      setTimeout(() => this.setState({ addingSucceded: false }), 2000);
    }).catch(() => {
      this.setState({ addingAttachment: false, addingFailed: true });

      setTimeout(() => this.setState({ addingFailed: false }), 2000);
    });
  }

  render() {
    if (this.state.addingSucceded) {
      return (
        <span className="left-buffer-md text-success">
          <FontAwesomeIcon className="right-buffer-sm" icon={faCheck} />
          Added
        </span>
      );
    }

    if (this.state.addingFailed) {
      return (
        <span className="left-buffer-md text-danger">
          <FontAwesomeIcon className="right-buffer-sm" icon={faTimes} />
          Something went wrong...
        </span>
      );
    }

    if (this.state.addingAttachment) {
      return (
        <span className="left-buffer-md">
          <FontAwesomeIcon icon={faSpinner} spin />
        </span>
      );
    }

    const tooltip = <Tooltip id="duplicateAttachment">Add to Project Attachments</Tooltip>;

    return (
      <span className="left-buffer-md" onClick={this.handleClick}>
        <OverlayTrigger overlay={tooltip} placement="top">
          <FontAwesomeIcon icon={faFileExport} />
        </OverlayTrigger>
      </span>
    );
  }
}

export default connect(null, { addAttachmentToProject })(AddAttachmentToProjectIcon);

